module.exports = __webpack_public_path__ + "images/home/cards/party-taco.5847e4d75e7bdd31ba97.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/home/cards/party-taco.svg
// module id = z/Sx
// module chunks = 1